import { fetchPost, fetchPatch, fetchDelete } from "../support/api-helpers";

class ExternalMappingManager {

  static makeFunctionsAvailable() {
    window.addMappingForPayment = ExternalMappingManager.addMappingForPayment;
    window.editMapping = ExternalMappingManager.editMapping;
    window.deleteMapping = ExternalMappingManager.deleteMapping;
  }
  // Function to add mapping for a specific payment
  static addMappingForPayment(paymentId, sourceType = '') {
    const externalSourceType = sourceType || prompt('Enter external source type (e.g., Hubspot):');
    if (!externalSourceType) return;

    const externalSourceId = prompt(`Enter ${externalSourceType} ID:`);
    if (!externalSourceId) return;

    // Create external mapping via the existing external mappings API using api-helpers
    fetchPost({
      url: '/admin/external_mappings',
      data: {
        external_mapping: {
          local_source_type: 'SubscriptionPayment',
          local_source_id: paymentId.toString(),
          external_source_type: externalSourceType,
          external_source_id: externalSourceId
        }
      }
    })
    .then(data => {
      // Reload the page to show the new mapping
      window.location.reload();
    })
    .catch(error => {
      console.error('Error creating mapping:', error);
      alert(`Error creating mapping: ${error.message}`);
    });
  }

  // Function to edit existing mapping
  static editMapping(mappingId) {
    const newSourceId = prompt('Enter new external source ID:');
    if (!newSourceId) return;

    // Update external mapping via the existing external mappings API using api-helpers
    fetchPatch({
      url: `/admin/external_mappings/${mappingId}`,
      data: {
        external_mapping: {
          external_source_id: newSourceId
        }
      }
    })
    .then(data => {
      // Reload the page to show the updated mapping
      window.location.reload();
    })
    .catch(error => {
      console.error('Error updating mapping:', error);
      alert(`Error updating mapping: ${error.message}`);
    });
  }

  // Function to delete mapping
  static deleteMapping(mappingId) {
    if (!confirm('Are you sure you want to delete this external mapping?')) {
      return;
    }

    // Delete external mapping via the existing external mappings API using api-helpers
    fetchDelete({
      url: `/admin/external_mappings/${mappingId}`
    })
    .then(data => {
      // Reload the page to show the mapping has been removed
      window.location.reload();
    })
    .catch(error => {
      console.error('Error deleting mapping:', error);
      // Still reload the page in case the deletion was successful but there was a logging error
      // Check if it's just a server error that doesn't affect the actual deletion
      if (error.message.includes('Internal Server Error')) {
        console.warn('Deletion may have succeeded despite error - reloading page');
        window.location.reload();
      } else {
        alert(`Error deleting mapping: ${error.message}`);
      }
    });
  }
}

export default ExternalMappingManager;
